import React, { useState, useEffect, useRef } from 'react';
import apiClient from '../api/client';
import ProductCard from './ProductCard';
import '../styles/FeaturedProducts.css';

const FeaturedProducts = ({ limit = 8 }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const carouselRef = useRef(null);

  useEffect(() => {
    loadFeaturedProducts();
  }, []);

  const loadFeaturedProducts = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Obtener productos promocionales
      const data = await apiClient.get('/ecommerce/product/promotional');
      
      if (Array.isArray(data)) {
        let filteredProducts = data;
        
        // Filtrar productos con precio 0 si está configurado
        const hideZeroPriceProducts = process.env.REACT_APP_HIDE_ZERO_PRICE_PRODUCTS === 'true';
        if (hideZeroPriceProducts) {
          filteredProducts = filteredProducts.filter(product => product.precio && product.precio > 0);
        }
        
        // Tomar solo los primeros 'limit' productos promocionales
        setProducts(filteredProducts.slice(0, limit));
      }
    } catch (err) {
      setError('No se pudieron cargar los productos promocionales');
    } finally {
      setLoading(false);
    }
  };

  const scroll = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = 320; // Ancho de tarjeta + gap
      const newScrollPosition = carouselRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
      
      carouselRef.current.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      });
    }
  };

  if (loading) {
    return (
      <div className="featured-loading">
        <div className="spinner"></div>
        <p>Cargando productos...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="featured-error">
        <p>{error}</p>
        <button className="btn btn-primary" onClick={loadFeaturedProducts}>
          Reintentar
        </button>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="featured-empty">
        <p>No hay productos disponibles en este momento</p>
      </div>
    );
  }

  return (
    <div className="featured-products">
      <div className="carousel-container">
        <button 
          className="carousel-button carousel-button-left"
          onClick={() => scroll('left')}
          aria-label="Anterior"
        >
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <div className="carousel-track" ref={carouselRef}>
          {products.map((product) => (
            <div key={product.id} className="carousel-item">
              <ProductCard product={product} />
            </div>
          ))}
        </div>

        <button 
          className="carousel-button carousel-button-right"
          onClick={() => scroll('right')}
          aria-label="Siguiente"
        >
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default FeaturedProducts;

